import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/_layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: 'validacion-biometrica',
        loadComponent: () =>
          import('./pages/validacion-biometrica/validacion-biometrica.component').then(
            m => m.ValidacionBiometricaComponent
          )
      },
      {
        path: '**',
        redirectTo: 'validacion-biometrica',
        pathMatch: 'full'
      }
    ]
  }
];
